import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const BlockIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 12.75 14.722">
      <path
        d="M40.548,0,34.3,3.608v7.217l6.25,3.608,6.25-3.608V3.608Zm4.981,3.852L40.548,6.727,35.567,3.852,40.548.977Zm-10.385.732L40.125,7.46v5.753l-4.981-2.876Zm5.827,8.628V7.46l4.981-2.875v5.752Z"
        transform="translate(-34.173 0.144)"
        fill={props.color || theme.palette.primary.main}
        stroke={props.color || theme.palette.primary.main}
        strokeWidth="0.25"
      />
    </SvgIcon>
  );
};
